import React, { useCallback, useEffect, useState } from "react";
import PropTypes from "prop-types";
import {
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalHeader,
  ModalOverlay,
} from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import PostsBulkImport from "./PostsBulkImport";

const PostsBulkImportModal = ({ onClose, ...rest }) => {
  const { t } = useTranslation(["planner"]);
  const [isInProgress, setIsInProgress] = useState(false);

  const handleProgress = useCallback(
    (value) => {
      setIsInProgress(value);
    },
    [setIsInProgress]
  );

  useEffect(() => {
    if (document.activeElement) {
      document.activeElement.blur();
    }
  }, []);

  return (
    <Modal
      autoFocus={false}
      returnFocusOnClose={false}
      initialFocusRef={() => null}
      isOpen
      onClose={onClose}
      size="2xl"
    >
      <ModalOverlay />
      <ModalContent>
        <ModalHeader
          paddingLeft="4"
          borderBottom="1px solid"
          borderColor="whiteAlpha.300"
        >
          {t("posts_bulk_import.modal.title")}
        </ModalHeader>
        <ModalBody padding="0">
          <PostsBulkImport
            onClose={onClose}
            onProgress={handleProgress}
            {...rest}
          />
        </ModalBody>
        <ModalCloseButton isDisabled={isInProgress} />
      </ModalContent>
    </Modal>
  );
};

PostsBulkImportModal.propTypes = {
  onClose: PropTypes.func.isRequired,
};

PostsBulkImportModal.defaultProps = {};

export default PostsBulkImportModal;
